import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React from "react";
import { useLoaderData } from "react-router-dom";
import CheckoutForm from "./CheckoutForm";

const stripePromise = loadStripe(
  "pk_test_51M6ZsVJ6ltQ4sxjkgYFH84YbxOXi4gRY2G3a2WBMQQvW88FSMvnPJGDjSA7YL5y3jtfEOl301M9jtpRTUlKWEVEr003qpwUhgE"
);

const Payment = () => {
  const booking = useLoaderData();
  // const navigation = useNavigation();
  const { treatment, price, appointmentDate, slot } = booking;
  // if (navigation.state === "loading") {
  //   return <Loading></Loading>;
  // }
  return (
    <div>
      <h3 className="text-3xl">Payment for {treatment}</h3>
      <p className="text-xl">
        Please pay <strong>${price}</strong> for your appointment on{" "}
        {appointmentDate} at {slot}
      </p>
      <div className="w-96 my-12">
        <Elements stripe={stripePromise}>
          <CheckoutForm booking={booking} />
        </Elements>
      </div>
    </div>
  );
};

export default Payment;
